import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
// import {  defineCustomElements } from 'xml-viewer-component/dist/loader'
import { AppComponent } from 'app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from 'app/app.config';

if (environment.production) {
  enableProdMode();
}

// provideEnvironmentNgxMask(maskConfig),

// platformBrowserDynamic().bootstrapModule(AppModule)
//   .catch(err => console.error(err));

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));

// defineCustomElements(window);